import type { TranslationKeysMapper } from '../types';
import { useFrontendLocalesStore } from '../store';

export default function useTranslationsMapper(): TranslationKeysMapper {
  const { addTranslationsMap } = useFrontendLocalesStore();

  return {
    addTranslationsMap,
  };
}
